(function($) {

  var $bpc_swiper = $('.block-postcarousel');
  if( $bpc_swiper.length ) {

    const swiper = new Swiper('.block-postcarousel__latest .block-postcarousel__swiper', {
      slidesPerView: 1.15,
      spaceBetween: 20,
      grabCursor: true,
      freeMode: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        576: {
          slidesPerView: 1.25,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 2.25,
          spaceBetween: 30,
        },
        1400: {
          slidesPerView: 2.25,
          spaceBetween: 30,
        },
        1700: {
          slidesPerView: 3.5,
          spaceBetween: 50,
        },
      }
    });

  }

})(jQuery);